import React from 'react';
export const DividerLabel = (props) => {
    const { children } = props;
    return (React.createElement("p", { className: "divider-with-text" },
        React.createElement("span", null, children)));
};
